import {
  buildCourseUrlRelative,
  buildProfessionalCertificateUrlRelative,
  buildProjectUrlRelative,
  buildS12nsUrlRelative,
} from 'bundles/common/utils/urlUtils';
import useXdpSubfolderPrefixPath from 'bundles/internationalization-lib/hooks/useXdpSubfolderPrefixPath';
import { ENTITY_TYPES } from 'bundles/unified-seo-content-common/constants';
import type { EntityType } from 'bundles/unified-seo-content-common/types';

type EntityCardLinkConfig = {
  entityType: EntityType;
  slug: string;
};

const useEntityCardLink = ({ entityType, slug }: EntityCardLinkConfig) => {
  const xdpSubfolderPrefixPath = useXdpSubfolderPrefixPath();

  switch (entityType) {
    case ENTITY_TYPES.course:
      return buildCourseUrlRelative(slug, '', xdpSubfolderPrefixPath);

    case ENTITY_TYPES.s12n:
      return buildS12nsUrlRelative(slug, '', xdpSubfolderPrefixPath);

    case ENTITY_TYPES.profS12n:
      return buildProfessionalCertificateUrlRelative(slug, '', xdpSubfolderPrefixPath);

    case ENTITY_TYPES.project:
      return buildProjectUrlRelative(slug, '', xdpSubfolderPrefixPath);

    case ENTITY_TYPES.mastertrack:
      return `/mastertrack/${slug}`;

    case ENTITY_TYPES.degree:
      return `/degrees/${slug}`;
  }
};

export default useEntityCardLink;
